/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { DownOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Divider,
  Dropdown,
  Form,
  Input,
  InputNumber,
  type MenuProps,
  Radio,
  Space,
  Switch,
} from "antd";
// import TextArea from "antd/lib/input/TextArea";
import Title from "antd/lib/typography/Title";
import React, { type ChangeEvent, useEffect, useState } from "react";
import CodeEditor from "@uiw/react-textarea-code-editor";

import { API } from "../../api/Api";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import {
  selectFullMidservice,
  sendConfigAsync,
} from "../../redux/slices/midservice/midserviceSlice";
import {
  type InstanceConfigType,
  type SendConfigType,
} from "../../redux/slices/midservice/midserviceTypes";
import { selectCanUserEdit } from "../../redux/slices/user/userSlice";
import yaml from "js-yaml";
import {
  objectToYaml,
  validateParams,
  SCHEMA_WITH_SECRETS,
} from "../../utils/yaml";
import { validateJson } from "../../utils/json";

type ValidateStatus = Parameters<typeof Form.Item>[0]["validateStatus"];

export interface FieldData {
  name: string | number | Array<string | number>;
  value?: any;
  touched?: boolean;
  validating?: boolean;
  errors?: string[];
}

interface EnumOptionsType {
  logRotate: string[];
  logLevel: string[];
  apiMode: string[];
}

interface CustomizedFormProps {
  onChange: (fields: FieldData[]) => void;
  fields: FieldData[];
}

enum Levels {
  availableModule = "available-module",
  module = "module",
  moduleParam = "module-param",
  availableRunner = "available-runner",
  runner = "runner",
  runnerParam = "runner-param",
}

interface IAdditionalParam {
  level: Levels;
  paramName: string;
  paramType: string;
  moduleName: string;
  runnerName?: string;
}

const removeAlreadyExistParams = (
  modules: string,
  allParams: IAdditionalParam[],
): IAdditionalParam[] => {
  const modulesYaml: any = yaml.load(modules);
  if (!modulesYaml?.length) {
    return allParams;
  }
  const moduleDict: Record<string, any> = {};
  for (const module of modulesYaml) {
    moduleDict[module.id] = module;
  }

  return allParams.filter((value): value is IAdditionalParam => {
    const module = moduleDict[value.moduleName];
    if (!module) {
      return true;
    }
    module.params = module.params ?? {};
    if (value.level === Levels.module && value.paramName in module) {
      return false;
    } else if (
      value.level === Levels.moduleParam &&
      value.paramName in module.params
    ) {
      return false;
    } else if (
      value.level === Levels.runner ||
      value.level === Levels.runnerParam
    ) {
      const runner = module.runs.find(
        (runner: any) => runner.call === value.runnerName,
      );
      runner.params = runner.params ?? {};

      if (value.level === Levels.runner && value.paramName in runner) {
        return false;
      } else if (
        value.level === Levels.runnerParam &&
        value.paramName in runner.params
      ) {
        return false;
      }
    }

    return true;
  });
};

const addAdditionalParam = (
  value: IAdditionalParam,
  modulesString: string,
): string => {
  const modulesYaml: any = yaml.load(modulesString) || [];
  if (value.level === Levels.availableModule) {
    modulesYaml.push({
      id: value.moduleName,
      runs: [],
    });
    return objectToYaml(modulesYaml);
  }

  const module = modulesYaml.find(
    (module: any) => module.id === value.moduleName,
  );
  const runner = module.runs.find(
    (runner: any) => runner.call === value.runnerName,
  );
  const paramPlaceholder = `введите значение типа: ${value.paramType}`;
  switch (value.level) {
    case Levels.module: {
      module[value.paramName] = paramPlaceholder;
      break;
    }
    case Levels.moduleParam: {
      module.params = module.params ?? {};
      module.params[value.paramName] = paramPlaceholder;
      break;
    }
    case Levels.availableRunner: {
      module.runs.push({
        call: value.runnerName,
        params: {},
      });
      break;
    }
    case Levels.runner: {
      runner[value.paramName] = paramPlaceholder;
      break;
    }
    case Levels.runnerParam: {
      runner.params = runner.params ?? {};
      runner.params[value.paramName] = paramPlaceholder;
      break;
    }
    default: {
      return `${modulesString.trimEnd()}\n${
        value.paramName
      }: ${paramPlaceholder}\n`;
    }
  }
  return objectToYaml(modulesYaml);
};

export const ConfigurationForm = ({
  fields,
  onChange,
}: CustomizedFormProps): JSX.Element => {
  const [form] = Form.useForm();

  const [enumOptions, setEnumOptions] = useState<EnumOptionsType>();
  const fullInstance = useAppSelector(selectFullMidservice);
  const canUserEdit = useAppSelector(selectCanUserEdit);

  const [configureParams, setConfigureParams] = useState<IAdditionalParam[]>(
    [],
  );
  const [items, setItems] = useState<MenuProps["items"]>([]);
  const [diagnosticsJson, setDiagnosticsJson] = useState<{
    value: string;
    validateStatus?: ValidateStatus;
    errorMsg?: string | null;
  }>({
    value: "",
  });

  const dispatch = useAppDispatch();

  const [modulesConf, setModulesConf] = useState<{
    value: string;
    validateStatus?: ValidateStatus;
    errorMsg?: string | null;
  }>({
    value: "",
  });

  // useEffect(() => {
  //   console.log("status", status)
  //   if (status == "loading") {
  //     message.loading({ content: 'Запрос отправлен', duration: 10});
  //   }
  //   else if (status == "success") {
  //     message.success({ content: 'Успешно', duration: 2});
  //   }
  //   else if (status == "failed") {
  //     message.warning({ content: 'Ответ не пришел', duration: 2});
  //   }
  // }, [status])

  useEffect(() => {
    form.setFields(fields);
    API.getMidserviceEnumOptions()
      .then((resp) => {
        console.log(resp.data);
        setEnumOptions(resp.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [fields]);

  const sendConfig = (): void => {
    if (fullInstance?.midserviceInstance?.deviceId == null) return;
    console.log("sendConfig fields", fields);
    const fieldsDict: Record<string, any> = {};
    fields.forEach((field: FieldData) => {
      fieldsDict[String(field.name)] = field.value;
    });
    if (fieldsDict.modules.length === 0) {
      fieldsDict.modules = [];
    } else {
      fieldsDict.modules = yaml.load(fieldsDict.modules, {
        schema: SCHEMA_WITH_SECRETS,
      });
    }
    if (fieldsDict.diagnostics.length === 0) {
      fieldsDict.diagnostics = {};
    } else {
      fieldsDict.diagnostics = JSON.parse(fieldsDict.diagnostics);
    }
    console.log("fieldsDict", fieldsDict);
    const sendConfigParams: SendConfigType = {
      deviceId: fullInstance.midserviceInstance.deviceId,
      domain: fullInstance.midserviceInstance.domain,
      config: fieldsDict as InstanceConfigType,
    };
    dispatch(sendConfigAsync(sendConfigParams));

    // message.info('Конфигурация отправлена');
  };

  const onModulesConfigChange = (
    event: ChangeEvent<HTMLTextAreaElement>,
  ): void => {
    const value = event.target.value;
    setModulesConf({
      ...validateParams(value),
      value,
    });
  };

  const onDiagnosticsChange = (
    event: ChangeEvent<HTMLTextAreaElement>,
  ): void => {
    const value = event.target.value;
    setDiagnosticsJson({
      ...validateJson(value),
      value,
    });
  };

  useEffect(() => {
    async function getAdditionalParams(): Promise<void> {
      const { data } = await API.getModulesParams(
        form.getFieldValue("modulesData"),
      );
      const addititonalParams: IAdditionalParam[] = [];

      data.forEach((module: any) => {
        const moduleJson: any = module.module;
        const runsJson: any[] = module.runs;

        Object.entries(moduleJson).forEach(([key, value]: [string, any]) => {
          if (key === "params") {
            Object.entries(value).forEach(
              ([param, paramValue]: [string, any]) => {
                addititonalParams.push({
                  level: Levels.moduleParam,
                  paramName: param,
                  paramType: paramValue,
                  moduleName: moduleJson.id,
                });
              },
            );
          } else if (key === "available_module") {
            addititonalParams.push({
              level: Levels.availableModule,
              paramName: value,
              paramType: key,
              moduleName: value,
            });
          } else {
            addititonalParams.push({
              level: Levels.module,
              paramName: key,
              paramType: value,
              moduleName: moduleJson.id,
            });
          }
        });
        runsJson.forEach((run: any) => {
          Object.entries(run).forEach(([key, value]: [string, any]) => {
            if (key === "params") {
              Object.entries(value).forEach(
                ([param, paramValue]: [string, any]) => {
                  addititonalParams.push({
                    level: Levels.runnerParam,
                    paramName: param,
                    paramType: paramValue,
                    moduleName: moduleJson.id,
                    runnerName: run.call,
                  });
                },
              );
            } else if (key === "available_run") {
              addititonalParams.push({
                level: Levels.availableRunner,
                paramName: value,
                paramType: key,
                moduleName: moduleJson.id,
                runnerName: value,
              });
            } else {
              addititonalParams.push({
                level: Levels.runner,
                paramName: key,
                paramType: value,
                moduleName: moduleJson.id,
                runnerName: run.call,
              });
            }
          });
        });
      });

      const filteredParams = removeAlreadyExistParams(
        form.getFieldValue("modules"),
        addititonalParams,
      );
      setItems(
        filteredParams.map((value: IAdditionalParam, index: number) => {
          return {
            key: index,
            label:
              value.level === Levels.availableModule ||
              value.level === Levels.availableRunner
                ? `<${value.level}> <${value.moduleName}> ${
                    value.runnerName ? value.runnerName : ""
                  }`
                : `<${value.level}> <${
                    value.runnerName ? value.runnerName : value.moduleName
                  }> ${value.paramName}: ${value.paramType}`,
            icon:
              value.level === Levels.availableModule ? (
                <img src="/icons/crossword.svg" alt="" />
              ) : value.level === Levels.availableRunner ? (
                <img src="/icons/sprint.svg" alt="" />
              ) : (
                <img src="/icons/settings_input_component.svg" alt="" />
              ),
          };
        }),
      );
      setConfigureParams(filteredParams);
    }
    try {
      getAdditionalParams();
    } catch (error: any) {
      console.error(error);
    }
  }, [modulesConf]);

  const updateModulesData = (newParam: IAdditionalParam): void => {
    if (newParam.level === Levels.availableModule) {
      const updatedModulesData = form.getFieldValue("modulesData") || [];
      updatedModulesData.push({
        moduleId: newParam.moduleName,
        runsCall: [],
      });
      form.setFieldValue("modulesData", updatedModulesData);
    }
    if (newParam.level === Levels.availableRunner) {
      const updatedModulesData = form
        .getFieldValue("modulesData")
        .map((module: any) => {
          if (module.moduleId === newParam.moduleName) {
            return {
              moduleId: module.moduleId,
              runsCall: [...(module.runsCall || []), newParam.runnerName],
            };
          }
          return module;
        });
      form.setFieldValue("modulesData", updatedModulesData);
    }
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    console.log("click", e);
    const newParam = configureParams[Number(e.key)];

    const newModulesString = addAdditionalParam(
      newParam,
      form.getFieldValue("modules"),
    );
    updateModulesData(newParam);
    setModulesConf({
      ...validateParams(newModulesString),
      value: newModulesString,
    });
    form.setFieldsValue({ modules: newModulesString });
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <Form
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 14 }}
      layout="horizontal"
      onFinish={() => {
        sendConfig();
      }}
      // style={{maxWidth: '950px'}}
      // onValuesChange={onFormLayoutChange}
      // disabled={componentDisabled}
    >
      <Title level={5}>Core</Title>
      <Form.Item
        label="backpressure_decay"
        name="backpressureDecay"
        tooltip={{
          title: "% снижения размера очереди для снятия backpressure",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <InputNumber max={100} min={0} />
      </Form.Item>
      <Form.Item
        label="data_dir"
        name="dataDir"
        tooltip={{
          title: "Директория для хранения производных файлов мидсервиса",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="queue_max_size"
        name="queueMaxSize"
        tooltip={{
          title: "Максимальный размер очереди в Mb",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <InputNumber min={0} />
      </Form.Item>
      <Form.Item
        label="workers_max_count"
        name="workersMaxCount"
        tooltip={{
          title:
            "Максимальное количество воркеров. 0 – по числу доступных CPU на машине",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <InputNumber min={0} />
      </Form.Item>

      <Divider />
      <Title level={5}>Service</Title>
      <Form.Item
        label="api_url"
        name="apiUrl"
        tooltip={{
          title: "Домен API",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <Input />
      </Form.Item>
      <Form.Item name="logRotate" label="log_rotate">
        <Radio.Group>
          {enumOptions?.logRotate.map((option) => {
            return (
              <Radio.Button key={option} value={option}>
                {option}
              </Radio.Button>
            );
          })}
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label="log_rotate_size"
        name="logRotateSize"
        tooltip={{
          title: "Ротация логов по размеру",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="log_store_days"
        name="logStoreDays"
        tooltip={{
          title: "Максимальный период хранения логов в днях",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <InputNumber min={0} />
      </Form.Item>
      <Form.Item
        label="access_key"
        name="accessKey"
        tooltip={{
          title: "Ключ аккаунта",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <Input />
      </Form.Item>
      <Form.Item name="logLevel" label="log_level">
        <Radio.Group>
          {enumOptions?.logLevel.map((option) => {
            return (
              <Radio.Button key={option} value={option}>
                {option}
              </Radio.Button>
            );
          })}
        </Radio.Group>
      </Form.Item>

      <Form.Item name="apiMode" label="api_mode">
        <Radio.Group>
          {enumOptions?.apiMode.map((option) => {
            return (
              <Radio.Button key={option} value={option}>
                {option}
              </Radio.Button>
            );
          })}
        </Radio.Group>
      </Form.Item>

      <Form.Item
        label="update_enable"
        name="updateEnable"
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>
      <Form.Item
        label="update_appcast_url"
        name="updateAppcastUrl"
        tooltip={{
          title: "Url с appcast.xml для обновлений мидсервиса",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="update_check_interval"
        name="updateCheckInterval"
        tooltip={{
          title: "Период проверки обновлений в секундах",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <InputNumber min={0} />
      </Form.Item>

      <Divider />
      <Title level={5}>Monitor</Title>
      <Form.Item
        label="heart_beat_timeout"
        name="heartBeatTimeout"
        tooltip={{
          title: "Период пинга в секундах",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <InputNumber min={0} />
      </Form.Item>
      <Form.Item
        label="personal_host"
        name="personalHost"
        tooltip={{
          title:
            "Хост мониторинга. Можно задать несколько списком через запятую",
          icon: <QuestionCircleOutlined />,
        }}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="personal_port"
        name="personalPort"
        tooltip={{ title: "Порт телеметрии", icon: <QuestionCircleOutlined /> }}
        rules={[{ required: true }]}
      >
        <InputNumber min={0} />
      </Form.Item>
      <Form.Item
        label="monitor_enabled"
        name="monitorEnabled"
        valuePropName="checked"
        rules={[{ required: true }]}
      >
        <Switch />
      </Form.Item>
      <Form.Item
        label="ssl"
        name="ssl"
        valuePropName="checked"
        rules={[{ required: true }]}
      >
        <Switch />
      </Form.Item>
      <Form.Item
        label="status_report_period"
        name="statusReportPeriod"
        tooltip={{
          title:
            "Интервал отправки статуса мидсервиса на телеметрию в секундах",
          icon: <QuestionCircleOutlined />,
        }}
        rules={[{ required: true }]}
      >
        <InputNumber min={0} />
      </Form.Item>
      <Divider />
      <Title level={5}>Proxy</Title>
      <Form.Item
        label="proxy_url"
        name="proxyUrl"
        tooltip={{
          title: "Url прокси",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="proxy_user"
        name="proxyUser"
        tooltip={{
          title: "Пользователь прокси",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="proxy_password"
        name="proxyPassword"
        tooltip={{
          title: "Пароль прокси",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="proxy_http_proto"
        name="proxyHttpProto"
        tooltip={{
          title:
            "Используемый в прокси-серверах протокол для переходов по http-ссылкам",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="proxy_https_proto"
        name="proxyHttpsProto"
        tooltip={{
          title:
            "Используемый в прокси-серверах протокол для переходов по https-ссылкам",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <Input />
      </Form.Item>

      <Divider />
      <Title level={5}>Modules</Title>
      <Form.Item
        label="modules"
        name="modules"
        validateStatus={modulesConf.validateStatus}
        help={modulesConf.errorMsg ?? ""}
        tooltip={{
          title: "YAML конфиг модулей",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <CodeEditor
          language="yaml"
          placeholder="Заполните параметры метода"
          // onChange={(evn) => setCode(evn.target.value)}
          padding={15}
          data-color-mode="light"
          style={{
            // border: params.errorMsg != null ? "1px solid red" : "",
            borderRadius: "2px",
            fontSize: 14,
            backgroundColor: "white",
            fontFamily:
              "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
          }}
          onChange={onModulesConfigChange}
        />
        {/* <TextArea
          showCount
          style={{ height: 120 }}
          placeholder="Конфиги модулей"
        /> */}
      </Form.Item>
      <Title level={5}>Дополнительные параметры конфигурации:</Title>

      <Form.Item label="additional params">
        <Dropdown menu={menuProps}>
          <Button>
            <Space>
              Добавить параметр метода
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
      </Form.Item>

      <Title level={5}>Диагностика</Title>

      <Form.Item
        label={"diagnostics"}
        name={"diagnostics"}
        validateStatus={diagnosticsJson.validateStatus}
        help={diagnosticsJson.errorMsg ?? ""}
        tooltip={{
          title: "JSON формат диагностики",
          icon: <QuestionCircleOutlined />,
        }}
      >
        <CodeEditor
          language="json"
          placeholder="Блок диагностики"
          padding={15}
          data-color-mode="light"
          style={{
            borderRadius: "2px",
            fontSize: 14,
            backgroundColor: "white",
            fontFamily:
              "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
          }}
          onChange={onDiagnosticsChange}
        ></CodeEditor>
      </Form.Item>

      <Divider />
      <Form.Item>
        <Button type="primary" htmlType="submit" disabled={!canUserEdit}>
          Сохранить
        </Button>
      </Form.Item>
    </Form>
  );
};
